import { ValidationInputType } from "@generation/core";
import { AbstractCrossFieldValidation } from "./AbstractCrossFieldValidation";
import { DateFormatEnum, formatStringToDate } from "@core/utils";
import { getValueFromObject } from "@generation/overview-core";

export abstract class AbstractCrossDateFieldValidation extends AbstractCrossFieldValidation {
  constructor(protected readonly datumTmProperty: string, protected readonly datumTmLabel: string) {
    super();
  }

  validate = (input: ValidationInputType): boolean => {
    const values = this.getValues();

    const endDateString = getValueFromObject(
      values,
      this.basePath ? `${this.basePath}.${this.datumTmProperty}` : this.datumTmProperty
    );

    if (typeof input !== "string" || !endDateString) {
      return true;
    }

    const startDate = formatStringToDate(input, DateFormatEnum.Date);
    const endDate = formatStringToDate(endDateString, DateFormatEnum.Date);

    return this.validateDates(startDate, endDate);
  };

  abstract validateDates(startDate: Date, endDate: Date) : boolean;
}
